import {
  generateRootObjectSchema,
  generateStringSchema,
  generateNumberSchema,
  generateColorSchema,
} from "components/cards/common/schema";
import {
  BaseAtomSpec,
  generateAtomContainerSchema,
} from "components/cards/atoms/BaseAtomSpec";
import {
  ImageParticleSpec,
  RichTextParticleSpec,
} from "components/cards/particles/YinzCam";

export const specification = new BaseAtomSpec(
  "About Profile Card",
  generateRootObjectSchema({
    container: generateAtomContainerSchema(),
      profileTitle: RichTextParticleSpec.generateSchema("Profile Title", "Shared title (always visible)."),
      image: ImageParticleSpec.generateSchema("Image", "Image shown on the image side."),
      bio: RichTextParticleSpec.generateSchema("Bio", "Bio shown on the bio side."),
      closedButtonImage: ImageParticleSpec.generateSchema("Closed Button Image", "Button image shown on the image side."),
      openButtonImage: ImageParticleSpec.generateSchema("Open Button Image", "Button image shown on the bio side."),
      initialSide: generateStringSchema("Initial Side", "Which side is shown first.", {
        choices: ["image", "bio"],
        choiceTitles: ["Image Side", "Bio Side"],
        defaultValue: "image",
      }),
      transitionMs: generateNumberSchema("Transition (ms)", "Duration for swapping between sides.", {
        defaultValue: 600,
      }),
      buttonEnterAnimation: generateStringSchema("Button Enter Animation", "Animation to play when the side's button image appears.", {
        choices: ["none", "pop", "spin"],
        choiceTitles: ["None", "Pop", "Spin"],
        defaultValue: "pop",
      }),
      buttonEnterAnimationMs: generateNumberSchema("Button Enter Animation (ms)", "Duration for the button enter animation.", {
        defaultValue: 450,
      }),
      cardAspectRatio: generateStringSchema("Card Aspect Ratio", "CSS aspect-ratio for the full card ", {
        defaultValue: "1 / 1",
      }),
      toggleIconMode: generateStringSchema("Toggle Icon Mode", "Use images from CMS, a CSS-drawn corner icon (^ style), or a CSS animated +/- icon.", {
        choices: ["image", "css", "css-plus-minus"],
        choiceTitles: ["Image", "CSS Corners", "CSS +/-"],
        defaultValue: "css",
      }),
      toggleIconColor: generateColorSchema("Toggle Icon Color", "Color used for the CSS corner icon (only when Toggle Icon Mode = CSS).", {
        defaultValue: "#000000",
      }),
      toggleButtonBgClosed: generateColorSchema("Toggle Button BG (Closed)", "Background color for the toggle button when closed (only when Toggle Icon Mode = CSS).", {
        defaultValue: "#ffffff",
      }),
      toggleButtonBgOpen: generateColorSchema("Toggle Button BG (Open)", "Background color for the toggle button when open/expanded (only when Toggle Icon Mode = CSS).", {
        defaultValue: "#f2d82c",
      }),
      profileTileBgClosed: generateColorSchema("Profile Tile BG (Closed)", "Background color for the profile title tile when closed/image side is visible.", {
        defaultValue: "#CABD98",
      }),
      profileTileBgOpen: generateColorSchema("Profile Tile BG (Open)", "Background color for the profile title tile when open/bio side is visible.", {
        defaultValue: "#FF4800",
      }),
  })
);
